// extracted by mini-css-extract-plugin
module.exports = {"Head":"MarketplaceItemVariantsTable_Head__1iN6Y","Cell":"MarketplaceItemVariantsTable_Cell__gxxqw"};